import { render, staticRenderFns } from "./AnatomyViewer.vue?vue&type=template&id=f62f13ce&scoped=true&"
import script from "./AnatomyViewer.vue?vue&type=script&lang=js&"
export * from "./AnatomyViewer.vue?vue&type=script&lang=js&"
import style0 from "./AnatomyViewer.vue?vue&type=style&index=0&id=f62f13ce&scoped=true&lang=css&"
import style1 from "./AnatomyViewer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f13ce",
  null
  
)

export default component.exports